
import { Component, Mixins } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import { SystemModule, AccountModule } from "@/store/modules";

const accountModule = getModule(AccountModule);

@Component({
  components: {
    Select
  }
})
export default class SearchOrderFilterSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  get options() {
    var options = accountModule.getSavedOrderSearchList.map(x => ({ label: x.text, value: x.value }));
    options.unshift({ label:"(No Filter)", value: null})
    return options;
  }
}
